<template>
  <article class="garage-price-list">
    <div v-if="!!popularServices?.length && !!garagePriceListWithCategories?.length">
      <template>
        <section class="garage-price-list__price-list">
          <GaragePriceListWithCategories
            :garage-price-list-with-categories="garagePriceListWithCategories"
            :mainContext="true"
            :premium="!!premium"
            :onlineBooking="onlineBooking"
            :sortByScore="true"
            @show-service-details="emits('show-service-details', $event)"
          />
        </section>
      </template>
    </div>
    <div v-if="!!otherServices?.length && !!garagePriceListWithCategories?.length">
      <h2
        v-if="mainContext ? !!otherServices.find(el => el?.flags?.virtual) : true"
        class="garage-price-list__header garage-price-list__header--other"
      >
        Inne usługi</h2>

      <section class="garage-price-list__price-list">
        <template
          v-for="(service, index) in otherServices"
          :key="service?.id || index"
        >
          <GaragePriceElement
            v-if="(mainContext ? service?.flags?.virtual : true)"
            :premium="premium"
            :onlineBooking="onlineBooking"
            :service="service"
            :mainContext="mainContext"
          />
        </template>
      </section>
    </div>

    <div
      v-if="!popularServices?.length && !otherServices?.length"
      class="garage-price-list__no-results"
    >
      <div v-if="route.meta.layout === 'modal'">
        <h2><span>Ups...</span> nic nie znaleźliśmy</h2>
        <p>Jeśli nie możesz znaleźć odpowiedniej usługi, opisz problem z samochodem, a warsztat zdiagnozuje usterkę i
          przygotuje wycenę naprawy.
        </p>

        <DmButton
          title="Opisz problem"
          @click="emits('set-other-reason-tab')"
        />
      </div>
    </div>

    <NuxtLink
      v-if="limit && !!garagePriceListWithCategories?.length"
      :to="route.path + '/services'"
    >
      <DmButton
        tertiary
        class="w-100 mt-5"
        title="Zobacz więcej"
      >
      </DmButton>
    </NuxtLink>
  </article>
</template>

<script setup lang="ts">
import GaragePriceElement from '@/components/GaragePriceElement.vue';
import GaragePriceListWithCategories from '@/components/GaragePriceListWithCategories.vue';
import { DmButton } from '@dobrymechanik/vue-ui-v2';
import type { PriceCategoryView, PriceElementView } from '~/api/docs/app';

interface IProps {
  garagePriceListWithCategories?: PriceCategoryView[];
  limit?: boolean;
  premium?: boolean;
  mainContext?: boolean;
  onlineBooking?: boolean;
}

interface IEmits {
  (name: 'set-other-reason-tab'): void;
  (name: 'show-service-details', value: PriceElementView): void;
}

// props
const props = withDefaults(defineProps<IProps>(), {
  limit: false
});

// emits
const emits = defineEmits<IEmits>();

// use 
const route = useRoute();

// computed 
const popularServices = computed(() => {
  return props.garagePriceListWithCategories?.flatMap(category => category.priceList?.filter(service => service.flags?.popular && !service.flags?.surcharge));
});

const otherServices = computed(() => {
  return props.garagePriceListWithCategories?.flatMap(category => category.priceList?.filter(service => !service.flags?.popular && !service.flags?.surcharge));
});

</script>

<style lang="scss" scoped>
@import url('assets/styles/components/garage-price-list.scss');
</style>